// sufan开发的可视化埋点系统

import mweixin from '../report/report_base.js';

import xhrCallCgi from '../common/ajaxcall.js';
import Env from '../common/env.js';
import WxGameJsCoreBridge from '../common/jscore/index.js';


export class MonitorReport {
  constructor(appid) {
    this.TAG = 'MonitorReport';

    if(!appid) {
      throw new Error(`[${this.TAG}] Must set appid first!`);
    }

    this._appid             = appid;
    this._params            = {};     // 上报参数
    this._cacheMonitorArray = [];     // 缓存中未上报的数据

    this._hbMonitorArray    = []; // 当前心跳列表
    this._heatbeatTimer     = null;
    this._heatbeatRate      = 60000;
  }
  destroy() {
    if(this._heatbeatTimer) {
      clearInterval(this._heatbeatTimer);
      this._heatbeatTimer = null;
    }
    this._params            = {};
    this._cacheMonitorArray = [];
    this._hbMonitorArray    = [];
  }
  setBase(params) {
    if(params !== null && typeof params === 'object') {
      this._params = params;
    }
    return this;
  }
  saveData(list = []) {
    if(list.length === 0) return;

    list.forEach((params = {}) => {
      if(!params.id) {
        throw new Error('Must provide a id!');
      }

      this._cacheMonitorArray.push(Object.assign({
        time  : Math.round(Date.now() / 1000),
      }, this._params, params));
    });

    return this;
  }
  send(list) {
    this.saveData(list);

    if(this._cacheMonitorArray.length > 0) {
      this._rpt(this._cacheMonitorArray);
    }
    this._cacheMonitorArray = [];

    return this;
  }

  /*-- 心跳上报：辅助计算人数占比监控点，例如视频加载错误率，需要实时的在线用户数 --*/
  addHbs(list = []) {
    list = list.filter((item = {}) => {
      let id = item.id;
      if(!id) {
        console.warn(`[${this.TAG} addHbs] ${id} not existed`);
        return false;
      };
      if(this.getHbMonitorPosition(id) > -1) {
        console.warn(`[${this.TAG} addHbs] ${id} had existed`);
        return false;
      }
      item.type = 1;
      Object.assign(item, this._params)
      return true;
    });
    if(list.length === 0) return;

    this._hbMonitorArray = this._hbMonitorArray.concat(list);

    if(!this._heatbeatTimer) {
      let step = () => {
        this._hbMonitorArray.forEach((item) => {
          Object.assign(item, this._params);
        });
        this._rpt(this._hbMonitorArray);
      };
      step();
      this._heatbeatTimer = setInterval(step, this._heatbeatRate);
    }

    return this;
  }
  removeHb(id) {
    let index = this.getHbMonitorPosition(id);
    if(index === -1) {
      console.warn(`[${this.TAG} removeHb] ${id} not exist`);
      return this;
    }
    this._hbMonitorArray.splice(index, 1);

    if(this._hbMonitorArray.length === 0 && this._heatbeatTimer) {
      clearInterval(this._heatbeatTimer);
      this._heatbeatTimer = null;
    }

    return this;
  }
  getHbMonitorPosition(id) {
    let position = -1;
    this._hbMonitorArray.some((m, i) => {
      if(m.id === id) {
        position = i;
        return true;
      }
    });
    return position;
  }

  getApt() {
    // 1: h5; 2: Wepkg; 4:JSCORE环境内 ;  8:预渲染环境； 共存状态如 jscore+ wepkg即 4 | 2 = 6
    // 存在jscore
    if(WxGameJsCoreBridge.hadJscoreInited()) {
      // 暂时先以数据全局变量__INITIAL_STATE__，来确定是已预渲染的页面
      if(typeof __INITIAL_STATE__ !== 'undefined') {
        return 8;
      }else{
        return 4 | (Env.isWepkg() ? 2 : 1);
      }
    }else{
      return Env.isWepkg() ? 2 : 1
    }
  }

  _rpt(list = [] ,cbk) {
    if(list.length === 0) return;

    var sysObj = mweixin.reportObj;
    var _report = [];
    for (var i = 0, il = list.length; i < il; i++) {
      var _o     = list[i];
      _report.push({
        "AppID"      : toString(_o.appId || this._appid),
        "PageKey"    : toString(_o.path || location.origin + location.pathname),
        "ReportType" : toNumber(_o.type),    // 1为心跳  0为普通上报
        "GameID"     : toString(_o.gameId),
        "MonitorID"  : toString(_o.id),
        "Value"      : toNumber(_o.value),
        "Time"       : toNumber(_o.time),
        "ExtreInfo"  : toString(_o.extreInfo),

        "CustomKey1"  : toString(_o.key1),
        "CustomKey2"  : toString(_o.key2),
        "CustomKey3"  : toString(_o.key3),
        "CustomKey4"  : toString(_o.key4),
        "CustomKey5"  : toString(_o.key5),
        "CustomKey6"  : toString(_o.key6),
        "CustomKey7"  : toString(_o.key7),
        "CustomKey8"  : toString(_o.key8),
        "CustomKey9"  : toString(_o.key9),
        "CustomKey10" : toString(_o.key10),
        "CustomKey11" : toString(_o.key11),
        "CustomKey12" : toString(_o.key12),
        "CustomKey13" : toString(_o.key13),
        "CustomKey14" : toString(_o.key14),
        "CustomKey15" : toString(_o.key15),

        "Device"       : toNumber((sysObj.device == 'iphone' ? 1 : 2)),
        "ClientVersion": toNumber(sysObj.clientVersion),

        "DeviceModel"  : '',
        "DeviceBrand"  : '',

        "WindowSize"   : `${window.innerWidth}x${window.innerHeight}`,
        "ScreenSize"   : `${window.outerWidth}x${window.outerHeight}`,
        "ConnectType"  : toNumber(sysObj.networktype || 1),
        "SdkVersion"   : 0,
        "Abt"          : this.getApt()
      });
    }
    ((_report, cbk) => {

      if( !Env.canIReport() ) {
        return
      }
      setTimeout(() => {
        request({
            // url     : `https://game.weixin.qq.com/cgi-bin/comm/perfstat?${baseStr}&${paramStr}`,
            url : `https://game.weixin.qq.com/cgi-bin/comm/perfstat`,
            method  : 'POST',
            data    : {
              "batchdata": _report
            },
            success : function(res){
                cbk && cbk('success');
            },
            fail    : function(res){
                cbk && cbk('fail');
            }
        });
      }, 100);
    })(_report, cbk)
  }
}
/**
 */
function request(param) {
  let self = this;
  let data = param.data || {};
  data.method = param.method || 'POST';

  xhrCallCgi(
      param.url,
          JSON.stringify(data),
      (res) => {
          param.complete && param.complete.call(self, res);
          param.success && param.success.call(self, res);
      },
      (res) => {
          param.complete && param.complete.call(self, res);
          param.fail && param.fail.call(self, res);
      }
  )
}

export function toNumber(n) {
  n = +n;
  if(typeof n !== 'number' || isNaN(n)) n = 0;
  return parseInt(n);
}

export function toString(n) {
  // NaN undefined 0 true false '' {}
  if(typeof(n) === 'number' && !isNaN(n)) {
    n = n + '';
  }

  return typeof(n) === 'string' ? n : ''
}
